import { createContext } from "react";

import { IAuth } from "../interfaces/IAuth";

export const AuthContext = createContext<{
  auth: IAuth | null;
  setAuth: Function;
}>({
  auth: null,
  setAuth: (value: any) => {},
});
